<div class="app-event-card">
  <a [routerLink]="'/event-details/' + event.eventSource.toLowerCase() + '/' + event.eventId">
    <div class="event-image-container">
      <div class="event-image-background" *ngIf="isImageVisible()" alt="" [ngStyle]="getBackgroundStyle()"></div>
    </div>
    <div class="event-image-container">
      <img class="event-image" alt="" *ngIf="isImageVisible(); else noImage" [src]="event.thumbnailUrl" />

      <ng-template #noImage>
        <p>No image is available.</p>
      </ng-template>
    </div>

    <h3 class="event-title header-1">
      {{ event.name }}
    </h3>

    <p class="event-time">
      {{ eventTime }}
    </p>

    <p class="event-description">
      {{ event.summary }}
    </p>

    <div class="event-info" title="Location">
      <ion-icon name="location-sharp" class="event-info-icon"></ion-icon>
      <p class="event-info-p">{{ shortLocation }}</p>
    </div>
    <div class="event-info event-price">
      <span class="event-info-icon-container" title="Price">
        <ion-icon name="logo-usd" class="event-info-icon"></ion-icon>
      </span>
      <div class="price-text-container" title="Price">
        <p class="price-text">{{ price }}</p>
      </div>
      <button class="uoa-icon-btn btn-dark-blue-inverse" *ngIf="!event.isSoldOut">
        <div (click)="checkout($event)">
          <p class="uoa-btn-text">{{event.isFree ? 'Register' : 'Buy tickets'}}</p>
          <ion-icon class="uoa-btn-icon" name="chevron-forward-outline"></ion-icon>
        </div>
      </button>
      <button class="uoa-btn btn-disabled" *ngIf="event.isSoldOut">
        <div class="sold-out-button">
          <p class="uoa-btn-text">Sold Out</p>
        </div>
      </button>
    </div>
  </a>
  <div class="overlay" *ngIf="event.isSoldOut"></div>
</div>
